/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import Notifications from '@auth/vue-share/utility/notifications';

export default {
    isNull(fields, obj, message = true) {
        for (const field of fields) {
            if (!obj[field] || (Array.isArray(obj[field]) && obj[field].length === 0)) {
                if (message) Notifications.error(`Das Feld ${field} wurde nicht gesetzt oder ist leer`);

                return true;
            }
        }

        return false;
    }
};
